import React, { useContext, useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import VideoUpload from "./VideoUpload";
import Loading from "../Loading";
import { FaPlus } from "react-icons/fa";
import ImgUpload from "./ImgUpload";
import { AuthContext } from "../../../context/AuthContext";

const EditImgBlog = () => {
  const [videos, setVideos] = useState();
  const [loading, setloading] = useState();
  useEffect(() => {
    stayLogin();
  }, []);

  const { user, setUser } = useContext(AuthContext);

  async function stayLogin() {
    setloading(true);
    await httpReauest("GET", "/blog/file/img", {}, {}).then(({ data }) => {
      setVideos(data?.data);
    });
    setloading(false);
  }

  async function handleCreate() {
    await httpReauest(
      "POST",
      "/blog/file/img",
      {},
      { "x-access-token": user.token }
    ).then(({ data }) => {
      stayLogin();
    });
  }

  if (loading) {
    <Loading />;
  }

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">گالری بلاگ در موبایل</h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
        {videos?.map((data) => (
          <ImgUpload key={data._id} data={data} stayLogin={stayLogin} />
        ))}
        <button
          className="flex justify-center items-center"
          onClick={handleCreate}
        >
          <FaPlus size={40} />
        </button>
      </div>
    </div>
  );
};

export default EditImgBlog;
